import { render, staticRenderFns } from "./CustomerChange.vue?vue&type=template&id=4619a3ce"
import script from "./CustomerChange.vue?vue&type=script&lang=js"
export * from "./CustomerChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports